import React, { useState, useEffect } from "react";
import { BankAccount } from "../../../models/bank.account.model";
import { CryptoAccount } from "../../../models/crypto.account.model";
import GenericModal from "./GenericModal";

type AccountFormModalProps = {
    type: "bank" | "crypto";
    mode: "add" | "edit";
    initialValues?: BankAccount | CryptoAccount | null;
    onSubmit: (formData: Partial<BankAccount> | Partial<CryptoAccount>) => void;
    onClose: () => void;
};

export default function AccountFormModal({
    type,
    mode,
    initialValues,
    onSubmit,
    onClose,
}: AccountFormModalProps) {
    const [formData, setFormData] = useState<
        Partial<BankAccount> | Partial<CryptoAccount>
    >({});

    useEffect(() => {
        if (initialValues) {
            setFormData(initialValues);
        } else {
            setFormData({});
        }
    }, [initialValues]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        onSubmit(formData);
    };

    return (
        <GenericModal
            title={
                mode === "add"
                    ? type === "bank"
                        ? "Új bankszámla hozzáadása"
                        : "Új cryptotárca hozzáadása"
                    : type === "bank"
                        ? "Bankszámla szerkesztése"
                        : "Cryptotárca szerkesztése"
            }
        >
            <div className="space-y-4">
                {type === "bank" && (
                    <>
                        <div>
                            <label className="block font-semibold">IBAN</label>
                            <input
                                type="text"
                                name="iban"
                                value={(formData as BankAccount).iban || ""}
                                onChange={handleChange}
                                className="border rounded p-2 w-full"
                            />
                        </div>
                        <div>
                            <label className="block font-semibold">Bank neve</label>
                            <input
                                type="text"
                                name="name"
                                value={(formData as BankAccount).name || ""}
                                onChange={handleChange}
                                className="border rounded p-2 w-full"
                            />
                        </div>
                        <div>
                            <label className="block font-semibold">Ország</label>
                            <input
                                type="text"
                                name="country"
                                value={(formData as BankAccount).country || ""}
                                onChange={handleChange}
                                className="border rounded p-2 w-full"
                            />
                        </div>
                    </>
                )}

                {type === "crypto" && (
                    <>
                        <div>
                            <label className="block font-semibold">Hálózat</label>
                            <input
                                type="text"
                                name="network"
                                value={(formData as CryptoAccount).network || ""}
                                onChange={handleChange}
                                className="border rounded p-2 w-full"
                            />
                        </div>
                        <div>
                            <label className="block font-semibold">Hálózati cím</label>
                            <input
                                type="text"
                                name="address"
                                value={(formData as CryptoAccount).address || ""}
                                onChange={handleChange}
                                className="border rounded p-2 w-full"
                            />
                        </div>
                        <div>
                            <label className="block font-semibold">Tőzsde neve</label>
                            <input
                                type="text"
                                name="exchange"
                                value={(formData as CryptoAccount).exchange || ""}
                                onChange={handleChange}
                                className="border rounded p-2 w-full"
                            />
                        </div>
                    </>
                )}
            </div>

            <div className="mt-6 flex justify-end space-x-3">
                <button
                    onClick={handleSubmit}
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                >
                    {mode === "add" ? "Hozzáadás" : "Mentés"}
                </button>
                <button
                    onClick={onClose}
                    className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                >
                    Mégse
                </button>
            </div>
        </GenericModal>
    );
}
